module.exports = __webpack_public_path__ + "img/Group 106@2x.24ae2a54.png";